import { createAction } from "@reduxjs/toolkit";
import type { UpdateTeacherStudioBody } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateTeacherStudio = createApiThunk<void, UpdateTeacherStudioBody>(
  "teacher/studio/update",
  async (body, { extra: { teacherRepository } }) => {
    await teacherRepository!.updateStudio(body);
  },
);

export const resetUpdateTeacherStudio = createAction("teacher/studio/resetUpdate");
